import { render, staticRenderFns } from "./pannier.vue?vue&type=template&id=87c5ed4c&scoped=true"
import script from "./pannier.vue?vue&type=script&lang=js"
export * from "./pannier.vue?vue&type=script&lang=js"
import style0 from "./pannier.vue?vue&type=style&index=0&id=87c5ed4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c5ed4c",
  null
  
)

export default component.exports